import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects, Parts} from "components";
import UserRoles from "constants/UserRoles";


const breadcrumbsStatic = [{
	name: 'Help Desks',
	url: '/helpdesks',
	icon: 'comments'
}];

class HelpDesksContacted extends Framework.Components.View {
	constructor(props) {
		super(props);
	}
	render() {
		let {history, roles} = this.props;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: "Engineer Contacted",
				url: `/helpdesks/contacted`,
				icon: 'laptop',
			}
		]);

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

				<Parts.Tickers.HelpdeskTicker/>

				<Collections.HelpDesksContacted
					history={history}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					regions={this.props.regions}
					showCSV={roles.includes(UserRoles.Admin)}
				/>

				<hr/>

			</div>
		);
	}
}

export default Framework.Components.withRootState(HelpDesksContacted);


